import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=1c53b8b8&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=ts&"
export * from "./Preview.vue?vue&type=script&lang=ts&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=1c53b8b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53b8b8",
  null
  
)

export default component.exports